// The newest Daily Chocobo issue, for the homepage's front-page card and the ticker: the newest paper's newest issue,
// with its number in the month (as ChocoboView counts it) and a short "when". One shared promise, so the card and the
// ticker load the month's issues once, and only after the page is up (they're ~150 KB).
import { PAPERS } from '../data/chocobo/papers.js';

let pending = null;
export function latestIssue() {
  if (!pending) {
    const paper = PAPERS[0];
    pending = paper.load().then((m) => {
      const issues = [...m.ISSUES].sort((a, b) => a.date.localeCompare(b.date));
      const issue = issues[issues.length - 1];
      return issue ? { paper, issue, no: issues.length } : null;
    }).catch(() => null);
  }
  return pending;
}

// "Yesterday" / "2 days ago" / "Oct 19": an issue covers its day's chat, so yesterday's is the fresh one.
export function issueWhen(date, now = new Date()) {
  const [y, m, d] = date.split('-').map(Number);
  const days = Math.round((new Date(now.getFullYear(), now.getMonth(), now.getDate()) - new Date(y, m - 1, d)) / 864e5);
  if (days === 0) return 'Today';
  if (days === 1) return 'Yesterday';
  if (days > 1 && days < 7) return days + ' days ago';
  return new Date(y, m - 1, d).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}
export const issueHref = (date) => '?chocobo&d=' + date;
